import { Routes, Route } from "react-router-dom";
import { MainLayout } from "../layout/MainLayout";
import OrderEntrySM from "../../features/orders/pages/OrderEditPage";
import OrderList from "../../features/orders/pages/OrderListPage";
import { PATHS } from "./paths";
import { LineList } from "../../features/customer-management/pages/CustomerManagementPage";
import { WaitTimeList } from "../../features/group-orders/pages/WaitingTimePage";
import Sales from "../../features/sales/pages/SalesPage";
import SellerProductsPage from "../../features/seller-products/pages/SellerProductsPage";
import { ProductDeadline } from "../../features/product-deadline/pages/ProductDeadlinePage";
import { ProductDeadlineCreatePage } from "../../features/product-deadline/pages/ProductDeadlineCreatePage";
import { ProtectedRoute } from "../../features/auth/components/ProtectedRoute";
import { RequireRole } from "../../features/auth/components/RequireRole";
import { RequirePermission } from "../../features/auth/components/RequirePermission";
import { RequireAnyPermission } from "../../features/auth/components/RequireAnyPermission";
import { LoginPage } from "../../features/auth/pages/LoginPage";
import { ForbiddenPage } from "../../features/auth/pages/ForbiddenPage";
import { ProposeListPage } from "../../features/proposes/pages/ProposeListPage";
import { ProposeEditPage } from "../../features/proposes/pages/ProposeEditPage";
import { ProposeViewPage } from "../../features/proposes/pages/ProposeViewPage";
import { CompanyRegistrationListPage } from "../../features/company-registrations/pages/CompanyRegistrationListPage";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path={PATHS.AUTH.LOGIN} element={<LoginPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path={PATHS.AUTH.FORBIDDEN} element={<ForbiddenPage />} />

        <Route element={<RequirePermission permission="app.sale.access" />}>
          <Route path="/" element={<MainLayout />}>
            <Route element={<RequireRole allowedRoles={["SALE", "PROPOSAL_COORDINATOR"]} />}>
              <Route index element={<OrderList />} />
              <Route path={PATHS.ORDERS.ROOT} element={<OrderList />} />
              <Route path={PATHS.ORDERS.CREATE_SINGLE} element={<OrderEntrySM />} />
              <Route path={PATHS.ORDERS.CREATE_MULTI} element={<OrderEntrySM />} />
              <Route path={PATHS.ORDERS.EDIT} element={<OrderEntrySM />} />
              <Route path={PATHS.ORDERS.VIEW} element={<OrderEntrySM />} />
              <Route path={PATHS.MASTER_DATA.CUSTOMERS} element={<LineList />} />
              <Route path={PATHS.WAIT_TIME.ROOT} element={<WaitTimeList />} />
              <Route path={PATHS.SALES.ROOT} element={<Sales />} />
              <Route path={PATHS.SELLER_PRODUCTS.ROOT} element={<SellerProductsPage />} />
              <Route path={PATHS.PRODUCT_DEADLINE.ROOT} element={<ProductDeadline />} />
              <Route path={PATHS.PRODUCT_DEADLINE.NEW} element={<ProductDeadlineCreatePage />} />
            </Route>
            <Route element={<RequirePermission permission="propose.coordinator.manage" />}>
              <Route path={PATHS.PROPOSES.CREATE} element={<ProposeEditPage />} />
              <Route path={PATHS.PROPOSES.EDIT} element={<ProposeEditPage />} />
            </Route>
            <Route element={<RequireAnyPermission permissions={["propose.coordinator.manage", "propose.seller.contribute"]} />}>
              <Route path={PATHS.PROPOSES.ROOT} element={<ProposeListPage />} />
            </Route>
            <Route element={<RequireAnyPermission permissions={["propose.coordinator.manage", "propose.seller.contribute"]} />}>
              <Route path={PATHS.PROPOSES.VIEW} element={<ProposeViewPage />} />
            </Route>
            <Route path={PATHS.COMPANY_REGISTRATIONS.ROOT} element={<CompanyRegistrationListPage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};
